import { loadView } from '@/router'

export default [
  {
    path: 'consignments',
    name: 'freight-consignments',
    component: loadView('Application/Freight/LegacyConsignments')
  },
  {
    path: 'consignments-v3',
    name: 'freight-consignments-v3',
    component: loadView('Application/Freight/Consignments'),
    redirect: {
      name: 'freight-consignments-v3-list'
    },
    children: [
      {
        path: 'list',
        name: 'freight-consignments-v3-list',
        component: loadView('Application/Freight/Consignments/List'),
        showInAlfred: true,
        alfredTitle: 'Freight - Consignments'
      },
      {
        path: ':consignmentId',
        name: 'freight-consignments-v3-consignment',
        component: loadView('Application/Freight/Consignments/Consignment'),
        redirect: {
          name: 'freight-consignments-v3-consignment-details'
        },
        children: [
          {
            path: 'details',
            name: 'freight-consignments-v3-consignment-details',
            component: loadView('Application/Freight/Consignments/Consignment/Details')
          },
          {
            path: 'tracking',
            name: 'freight-consignments-v3-consignment-tracking',
            component: loadView('Application/Freight/Consignments/Consignment/Details')
          },
          {
            path: 'notes',
            name: 'freight-consignments-v3-consignment-notes',
            component: loadView('Application/Freight/Consignments/Consignment/Notes')
          },
          {
            path: 'pricing',
            name: 'freight-consignments-v3-consignment-pricing',
            component: loadView('Application/Freight/Consignments/Consignment/History')
          },
          {
            path: 'history',
            name: 'freight-consignments-v3-consignment-history',
            component: loadView('Application/CustomerService/Pickups/Pickup/History')
          },
          {
            path: 'manifest',
            name: 'freight-consignments-v3-consignment-manifest',
            component: loadView('Application/Freight/Consignments/Consignment/Manifest')
          },
          {
            path: 'enquiries',
            name: 'freight-consignments-v3-consignment-enquiries',
            component: loadView('Application/Freight/Consignments/Consignment/Enquiries')
          },
          {
            path: 'attachments',
            name: 'freight-consignments-v3-consignment-attachments',
            component: loadView('Application/Freight/Consignments/Consignment/Attachments')
          },
          {
            path: 'watchlist',
            name: 'freight-consignments-v3-consignment-watchlist',
            component: loadView('Application/Freight/Consignments/Consignment/Watchlist')
          }
        ]
      }
    ]
  }
]
